// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"553":"27bc590b","950":"33407329"}[chunkId] + ".css";
};